//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { ButtonLink, Column, Row } from "components/styles";
import { ListItemInactivity } from "./styles";
//#endregion
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
import { getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";
import { getTimeParts } from "components/CustomTimePicker/utils";
import { getText as getTextTime } from "components/CustomTimePicker/utils";
import { getDateAsNumericText } from "components/CustomDatePicker/utils/helpers";
import InactivityDataFieldsDialog from "../InactivityDataFieldsDialog/InactivityDataFieldsDialog";
//#endregion

const InactivityDataFields = ({
    time, allDays
}) => {
    //#region States
    const [showDialog, setShowDialog] = useState(false);
    //#endregion
    //#region Functions
    const toggleShowDialog = (value = null) => {
        setShowDialog(value !== null ? value : !showDialog);
    }
    const getResumeInactivityItem = () => {
        // Agrupando día, fecha y horas de inactividad
        const group = time.reduce((group, timeItem) => {
            // Obteniendo nombre del día
            const dayName = getDayNameById(timeItem.dayId);
            const returnGroup = timeItem.inactivity.reduce((newGroup, {
                date, 
                time
            }) => {
                // Obteniendo fecha y hora en cadena
                const timeStr = `${getTextTime(getTimeParts(time.start))} - ${getTextTime(getTimeParts(time.end))}`;
                const idxItem = newGroup.findIndex(({ date: currentDate }) => {
                    return currentDate === date;
                });
                // Verificando si el elemento con la misma existe para empezar el agrupamiento o agregar al grupo respectivo
                if (idxItem >= 0) {
                    const copyNewGroup = [...newGroup];
                    copyNewGroup[idxItem].inactivities.push(timeStr);
                    return copyNewGroup;
                }
                return [
                    ...newGroup,
                    {
                        dayName,
                        date,
                        inactivities: [timeStr]
                    }
                ];
            }, []);
            return [
                ...group,
                ...returnGroup
            ];
        }, []);
        // Ordenando en función de la fecha
        group.sort((a, b) => a.date > b.date ? 1 : -1);
        // Parseando fecha en milis. a fecha string
        return group.map(item => {
            const dateStr = getDateAsNumericText(getDatePartsByMillis(item.date));
            return {
                ...item,
                date: dateStr
            };
        });
    }
    const getDayNameById = dayId => allDays.find(({ id }) => id === dayId)?.name || "-";
    const renderFields = ({dayName, date, inactivities}, idx) => {
        return (
            <ListItemInactivity key={idx}>
                <h3>{dayName}</h3>
                <h5>{date}</h5>
                {inactivities.filter((_, idx) => idx < 2).map((el, idx) => (
                    <h4 key={idx}>{el}</h4>
                ))}
                {inactivities.length > 2 && <span>...</span>}
            </ListItemInactivity>
        );
    };
    const distinctResumeInactivityItem = (acc, obj) => {
        if(!acc.some(({ dayName }) => dayName === obj.dayName)) 
            return [...acc, obj];
        return acc;
    }
    //#endregion
    const resumeInactivityItem = getResumeInactivityItem();
    return (
        <Column gap="0">
            <Row align="flex-start" gap="40px">
                {resumeInactivityItem
                .reduce(distinctResumeInactivityItem, [])
                .map(renderFields)}
            </Row>
            {time.some(el => el.inactivity.length > 2) && 
                <ButtonLink onClick={() => setShowDialog(true)}>
                    Ver más horas de inactividad
                </ButtonLink>}
            <InactivityDataFieldsDialog 
                inactivity={resumeInactivityItem}
                show={showDialog}
                toggleShow={toggleShowDialog}
                time={time}
                getDayNameById={getDayNameById}/>
        </Column>
    );
}

export default InactivityDataFields;